import { render, staticRenderFns } from "./dialogUse.vue?vue&type=template&id=65bbb632&scoped=true&"
import script from "./dialogUse.vue?vue&type=script&lang=js&"
export * from "./dialogUse.vue?vue&type=script&lang=js&"
import style0 from "./dialogUse.vue?vue&type=style&index=0&id=65bbb632&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bbb632",
  null
  
)

export default component.exports